import React from 'react';
import PropTypes from 'prop-types';
import AccountProfileForm from './Form';

const AccountProfileView = ({ data, refetchData }) => {
  return (
    <div>
      <AccountProfileForm initialData={data} refetchData={refetchData} />
    </div>
  );
};

AccountProfileView.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  refetchData: PropTypes.func.isRequired,
};

AccountProfileView.defaultProps = {
  data: {},
};

export default AccountProfileView;
